import React from "react";
import { Check, Sparkles } from "lucide-react";
import { TID } from "@/lib/testIds";

function Card({ title, price, mrp, save, off, highlight, badge, onBuy, testIdCard, testIdBtn, ctaLabel }) {
  return (
    <div
      data-testid={testIdCard}
      className={`relative flex flex-col rounded-3xl p-6 ${
        highlight
          ? "border border-[#FF7A00]/60 bg-gradient-to-b from-[#1a0d02] to-[#0b0603] glow-orange"
          : "border border-white/10 bg-neutral-950/70"
      }`}
    >
      {badge && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-fire px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-black shadow-lg">
          <Sparkles size={12} className="mr-1 inline" /> {badge}
        </div>
      )}
      <div className="text-[11px] uppercase tracking-[0.28em] text-neutral-400">{title}</div>
      <div className="mt-3 flex items-baseline gap-3">
        <span className="font-display text-6xl text-white">₹{price}</span>
        {mrp && (
          <span className="text-lg text-neutral-500 line-through">₹{mrp}</span>
        )}
      </div>
      {save && (
        <div className="mt-1 flex items-center gap-2 text-sm">
          <span className="text-[#FFC107]">Save ₹{save}</span>
          <span className="rounded-md bg-[#FF7A00]/15 px-2 py-0.5 text-xs font-bold text-[#FF7A00]">
            {off}% OFF
          </span>
        </div>
      )}
      <ul className="mt-5 space-y-2 text-sm text-neutral-300">
        <li className="flex items-start gap-2">
          <Check size={16} className="mt-0.5 shrink-0 text-[#FF7A00]" />
          1 bottle · 30 day supply
        </li>
        <li className="flex items-start gap-2">
          <Check size={16} className="mt-0.5 shrink-0 text-[#FF7A00]" />
          <span>
            FREE Customized Diet Plan
            <span className="ml-1 text-[11px] uppercase tracking-widest text-[#FFC107]">Worth ₹500</span>
          </span>
        </li>
        <li className="flex items-start gap-2">
          <Check size={16} className="mt-0.5 shrink-0 text-[#FF7A00]" />
          <span>
            FREE Virtual Personal Trainer
            <span className="ml-1 text-[11px] uppercase tracking-widest text-[#FFC107]">Worth ₹2500</span>
          </span>
        </li>
        <li className="flex items-start gap-2">
          <Check size={16} className="mt-0.5 shrink-0 text-[#FF7A00]" />
          {highlight ? "Priority processing" : "Cash on Delivery available"}
        </li>
      </ul>
      <button
        data-testid={testIdBtn}
        onClick={onBuy}
        className={`mt-6 rounded-full py-3 text-sm font-bold uppercase tracking-wider transition-transform hover:scale-[1.02] active:scale-[0.98] ${
          highlight
            ? "bg-fire text-black animate-pulse-orange"
            : "border border-white/15 bg-white/5 text-white hover:bg-white/10"
        }`}
      >
        {ctaLabel}
      </button>
    </div>
  );
}

export default function Pricing({ onBuyPrepaid, onBuyCod }) {
  return (
    <section id="pricing" className="relative bg-black px-5 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mb-10 text-center">
          <div className="text-xs uppercase tracking-[0.3em] text-[#FF7A00]">Pricing</div>
          <h2 className="mt-2 font-display text-4xl text-white sm:text-5xl">
            Choose Your <span className="text-fire">Power</span> Pack
          </h2>
          <p className="mt-2 text-sm text-neutral-400">
            Same premium formula. Pick the plan that suits you.
          </p>
        </div>
        <div className="grid gap-4 md:grid-cols-3">
          <Card
            testIdCard={TID.pricingMrp}
            testIdBtn="pricing-mrp-note"
            title="MRP"
            price="2000"
            ctaLabel="Regular Price"
            onBuy={() => {}}
          />
          <Card
            testIdCard={TID.pricingPrepaid}
            testIdBtn={TID.pricingBuyPrepaid}
            title="Prepaid Offer"
            price="749"
            mrp="2000"
            save="1251"
            off="63"
            highlight
            badge="Best Value"
            ctaLabel="Pay Online — ₹749"
            onBuy={onBuyPrepaid}
          />
          <Card
            testIdCard={TID.pricingCod}
            testIdBtn={TID.pricingBuyCod}
            title="Cash on Delivery"
            price="799"
            mrp="2000"
            save="1201"
            off="60"
            ctaLabel="Order COD — ₹799"
            onBuy={onBuyCod}
          />
        </div>
      </div>
    </section>
  );
}
